import React, { Component } from "react";
import Grid from '@mui/material/Grid';
import SpinnerModal from "@components/SpinnerModal";
import { useDialog } from 'react-st-modal';
import styles from './updateroledialog.module.css';
import SupportAlert from '@components/SupportAlert';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Switch from '@mui/material/Switch';

class UpdateRoleDialog extends Component {
    state = {
        loading: false,

        roleName: '',
        roleDescription: '',
        roleActive: false,

        validRoleName: true,
        validRoleDescription: true,
        validRoleActive: true,

        selectedRole: null,
        roleActions: [],
    }

    async componentDidMount() {
        this.setState({ loading: true });

        this.setState({ selectedRole: this.props.role });
        this.setState({ roleActive: this.props.role.active });
        this.setState({ roleName: this.props.role.name });
        this.setState({ roleDescription: this.props.role.description });

        let rolesActions = this.props.systemRoles.sort((a, b) => a.action > b.action ? 1 : -1).map(systemRole => {
            return { value: systemRole.action, label: systemRole.action };
        });

        this.setState({ roleActions: rolesActions });

        this.setState({ loading: false });
    }

    handleChangedValue = (evt) => {
        switch (evt.target.name) {
            case 'role_name': {
                this.setState({ validRoleName: (evt.target.value !== undefined && evt.target.value !== null && evt.target.value.trim() !== '') });
                this.setState({ roleName: evt.target.value.toUpperCase() });
                break;
            }
            case 'description': {
                this.setState({ validRoleDescription: (evt.target.value !== undefined && evt.target.value !== null && evt.target.value.trim() !== '') });
                this.setState({ roleDescription: evt.target.value });
                break;
            }
            case 'role_active': {
                const newValue = !this.state.roleActive;
                this.setState({ validRoleActive: true });
                this.setState({ roleActive: newValue });
                break;
            }
            default: {
                break;
            }
        }
    }

    getData() {

        let data = {
            actionById: this.props.surveysUserId,
            rdiRole: {
                id: this.props.role.id,
                name: this.state.roleName,
                description: this.state.roleDescription,
                active: this.state.roleActive
            }
        };

        return data;

    }

    dialogBody() {

        return <div className={styles.flex_row_container}>
            <div className={styles.featuredItem}>
                <h1>
                    <text className={styles.featuredTitleHeader}>{"Current Role"}</text>
                </h1>
                <br />
                <p>
                    <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                        <Grid container item xs={12}>
                            <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                                <Grid container item xs={6}>
                                    <TextField
                                        disabled={true}
                                        className={styles.dialogInputs}
                                        require="required"
                                        name={'role_name'}
                                        type="text"
                                        placeholder={'Role Name'}
                                        id="outlined-basic"
                                        size="small"
                                        label={'Role Name'}
                                        required
                                        value={this.props.role.name.toUpperCase()}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid container item xs={6} >
                                    <FormControl>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    disabled={true}
                                                    name={'role_active'}
                                                    size='small'
                                                    color='primary'
                                                    sx={{ m: 1 }}
                                                    checked={(this.props.role.active)}
                                                />
                                            }
                                            label={this.props.role.active ? "Active" : "Disabled"}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </p>
                <p>
                    <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                        <Grid container item xs={12}>
                            <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                                <Grid container item xs={6}>
                                    <TextField
                                        disabled={true}
                                        name={'description'}
                                        className={styles.dialogInputs}
                                        id="outlined-multiline-static"
                                        label="Description"
                                        multiline
                                        rows={4}
                                        placeholder={'Ipsum lorem ..'}
                                        defaultValue=" "
                                        required
                                        value={this.props.role.description}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </p>
            </div>
            <div className={styles.featuredItem}>
                <h1>
                    <text className={styles.featuredTitleHeader}>{"Updated Role"}</text>
                </h1>
                <br />
                <p>
                    <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                        <Grid container item xs={12}>
                            <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                                <Grid container item xs={6}>
                                    <TextField
                                        disabled={false}
                                        className={styles.dialogInputs}
                                        require="required"
                                        name={'role_name'}
                                        type="text"
                                        placeholder={'Role Name'}
                                        id="outlined-basic"
                                        size="small"
                                        label={'Role Name'}
                                        required
                                        value={this.state.roleName.toUpperCase()}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onChange={(evt) => this.handleChangedValue(evt)}
                                    />
                                </Grid>
                                <Grid container item xs={6} >
                                    <FormControl>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    disabled={false}
                                                    name={'role_active'}
                                                    size='small'
                                                    color='primary'
                                                    sx={{ m: 1 }}
                                                    checked={(this.state.roleActive)}
                                                    onChange={(evt) => this.handleChangedValue(evt)}
                                                />
                                            }
                                            label={this.props.role.active ? "Active" : "Disabled"}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </p>

                <p>
                    <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                        <Grid container item xs={12}>
                            <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                                <Grid container item xs={6}>
                                    <TextField
                                        disabled={false}
                                        name={'description'}
                                        className={styles.dialogInputs}
                                        id="outlined-multiline-static"
                                        label="Description"
                                        multiline
                                        rows={4}
                                        placeholder={'Ipsum lorem ..'}
                                        defaultValue=" "
                                        required
                                        value={this.state.roleDescription}
                                        onChange={(evt) => this.handleChangedValue(evt)}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </p>
            </div>
        </div>
    }

    render() {
        if (this.state.loading === true) {
            return <SpinnerModal settings={true} label={'Dialog loading ...'} />
        } else {
            return <DialogWrapper
                {...this.props}
                onClick={(evt) => this.props.nextButton.onClick(evt, this.getData())}
                validDetails={(this.state.validRoleName === true) &&
                    (this.state.validRoleDescription === true) &&
                    (this.state.validRoleActive === true)}
                content={
                    <React.Fragment>
                        {this.dialogBody()}
                    </React.Fragment>
                }
            />
        }
    }

}
export default UpdateRoleDialog;

function DialogWrapper(props) {
    const dialog = useDialog();

    return (
        <div>
            <br />
            <div>
                {props.content}
            </div>
            <div>
                {props.backButton !== undefined && props.backButton !== null
                    ? <button type="button" className="btnBack"
                        onClick={() => {
                            dialog.close(false);
                        }}
                    >
                        {props.backButton.text}
                    </button>
                    : <div />
                }
                {props.nextButton !== undefined && props.nextButton !== null
                    ? <button type="button" className="btnNext"
                        onClick={(evt) => {
                            if (!props.validDetails) {
                                SupportAlert.displayAlert('Updating role failed', 'Please review supplied information carefully.');
                            } else {
                                props.onClick(evt);
                                dialog.close(true);
                            }
                        }}
                    >
                        {props.nextButton.text}
                    </button>
                    : <div />
                }
            </div>
        </div>
    );
}

